import MarkerClusterer from '@google/markerclustererplus';

var searchOptions = {
    'categories': [],
    'communes': [],
    'covid': 1
};
var markers = [];
var emptyLocations = [];
var markerCluster = null;
var refreshdata = null;
var zoomLevel = 8.5;

var communesLoc = [];

$(document).ready(function(){

    $('#adresse').on('input', function() {
        if($(this).val() == "") {
            searchOptions.lat = 0;
            searchOptions.lng = 0;
            loadResults(searchOptions);
            map.setCenter({lat: 50.498531, lng: 4.6484551});
            map.setZoom(zoomLevel);
        }
    });
    
    $('.cat-icon').click(function(e) {
        e.preventDefault();

        var categoryId = $(this).attr('data-category');
        if(categoryId.indexOf(',') != -1) {
            categoryId = categoryId.split(',');
        } else {
            categoryId = [categoryId];
        }

        if(!$(this).hasClass('active')) {
            searchOptions.categories = searchOptions.categories.concat(categoryId);
        } else {
            for(var i in categoryId) {
                var index = searchOptions.categories.indexOf(categoryId[i]);
                if (index !== -1) searchOptions.categories.splice(index, 1);
            }
        }
        $(this).toggleClass('active');

        loadResults(searchOptions);
        
    });

    
    // Select2 - Communes
    $('#town-select').select2({
        placeholder: 'Communes déservies',
        ajax: {
            url: 'api/get-towns.php',
            dataType: 'json',
            processResults: function (data) {
                for(var index in data) {
                    data[index]["text"] = data[index]["name"];

                }
                return {
                    results: data
                };
            }
        }
    });
    $('#town-select').on('select2:select', function (e) {
        var data = e.params.data;
        searchOptions.communes.push(data.id);
        
        loadResults(searchOptions);
    });
    $('#town-select').on('select2:unselect', function (e) {
        var data = e.params.data;
        var index = searchOptions.communes.indexOf(data.id);
        if (index !== -1) searchOptions.communes.splice(index, 1);

        loadResults(searchOptions);
    });

    $('#covid').click(function(e) {
        searchOptions.covid = $(this).is(':checked') ? 1 : 0;
        loadResults(searchOptions);
    });

    // Dropdown cats en responsive
    $('.label-filtre').on('click',function(){
        $(this).toggleClass('open');
        $('.wrapcats ul').toggleClass('active');
    });
    $('.cat-icon').on('click',function(e){
        e.preventDefault();
        $('.label-filtre').toggleClass('open');
        $('.wrapcats ul').toggleClass('active');
    });
});

var map;
// Google maps initialization
window.initMaps = function()
{
    // Google Maps autocomplete
    // var input = document.getElementById('adresse');
    // var autocomplete = new google.maps.places.Autocomplete(input, {
    //     componentRestrictions: {country: 'be'}
    // });
    // autocomplete.addListener('place_changed', function () {
    //     if(autocomplete.getPlace().geometry) {
    //         searchOptions.lat = autocomplete.getPlace().geometry.location.lat();
    //         searchOptions.lng = autocomplete.getPlace().geometry.location.lng();

    //         map.setCenter({lat: searchOptions.lat, lng: searchOptions.lng});
    //         map.setZoom(14);

    //         //console.log(searchOptions);
    //         loadResults(searchOptions);
    //     }
    // });

    if($('#map').length) {
        // console.log('maaap');
        map = new google.maps.Map(document.getElementById('map'), {
            center: {lat: 50.498531, lng: 4.6484551},
            zoom: zoomLevel,
            fullscreenControl: false,
            keyboardShortcuts: false,
            mapTypeControl: false
        });
        
        // map.addListener('bounds_changed', () => {
        //     $('.results-loading').addClass('active');
        //     if(refreshdata == null) {
        //         refreshdata = setTimeout(refreshResults, 1000);
        //     } else {
        //         clearTimeout(refreshdata);
        //         refreshdata = setTimeout(refreshResults, 1000);
        //     }
        // });

        
        loadResults(searchOptions);
    }

}

function refreshResults() {
    $('#results-load').html('');
    var resultCount = 0;
    for (var i=0; i < markers.length; i++) {
        //if (map.getBounds().contains(markers[i].getPosition())) {
            var isEmpty = false;
            for(var emptyI=0; emptyI < emptyLocations.length; emptyI++) {
                if(markers[i].location.id == emptyLocations[emptyI].id) {
                    isEmpty = true;
                }
            }

            if(!isEmpty) {
                $('#results-load').loadTemplate($('#result-item'), markers[i].location, { append: true });
                resultCount++;
            } else {
                //console.log('EMPTY', markers[i].location);
            }
        //}
    }
    if(emptyLocations.length > 0) {
        $('#results-load').append('<h4>Résultats non localisés</h4>');
        for (var i=0; i < emptyLocations.length; i++) {
            $('#results-load').loadTemplate($('#result-item'), emptyLocations[i], { append: true });
            resultCount++;
        }
    }
    $('#results-load').prepend('<span class="nb-results">'+resultCount + ' prestataires trouvés</span>');
    $('.results-loading').removeClass('active');
}

var xhr = false;

function loadResults(options) {

    //$('.navbar').addClass('blocked');
    if(markerCluster !== null) {
        markerCluster.clearMarkers();
    }
    console.log(options);
    markers = [];
    emptyLocations = []; // Store location withou localization

    $('.open').removeClass('open');
    $('.map-loading').addClass('active');
    $('.results-loading').addClass('active');
    var activeInfoWindow;

    if(xhr) {
        xhr.abort();
        xhr = null;
    }
    xhr = $.ajax('api/get-map-data.php', {
        'data': options,
        'method': 'post',
        'dataType': 'json',
        'success': function(data) {
            markers = data.map(function(location, i) {

                if((location.lat == null) || (location.lng == null)) {
                    emptyLocations.push(location);
                } 
                
                    var htmlmarker = '<div class="infomarker"><h4>' + location.title + '</h4><a href="'+ location.link +'" target="_blank">Plus d\'informations</a></div>';
                    var infowindow = new google.maps.InfoWindow({
                        content: htmlmarker
                    });
                    var marker = new google.maps.Marker({
                        position: { lat: parseFloat(location.lat), lng: parseFloat(location.lng) },
                        icon: 'http://p3309.phpnet.org/test-filtre/map/img/marker.png',
                        title: location.title,
                        location: location
                    });
                    marker.addListener('click', function() {

                        if (activeInfoWindow) { activeInfoWindow.close();}
                        infowindow.open(map, marker);
                        activeInfoWindow = infowindow;
                    });
                    return marker;
                
            });
            
            markerCluster = new MarkerClusterer(map, markers,
                {imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m', minimumClusterSize: 3});
                refreshResults();
                $('.map-loading').removeClass('active');
                $('.results-loading').removeClass('active');
                $('.colmap').addClass('active');
                $('.colresults').addClass('active');
                
            xhr = false;
        }
    });

}